import axios from "axios"

const fetchGalleryRequest = () => {
	return {type: "FETCH_GALLERY_REQUEST"}
}

const fetchGallerySuccess = (gallery) => {
	return {type: "FETCH_GALLERY_SUCCESS", payload: gallery}
}

const fetchGalleryFailure = (error) => {
	return {type: "FETCH_GALLERY_FAILURE", payload: error}
}

export const fetchGallery = () => {
	return (dispatch) => {
		dispatch(fetchGalleryRequest())
		axios.get("p/gallery")
		.then(response => {
			const gallery = response.data
			dispatch(fetchGallerySuccess(gallery))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchGalleryFailure(error))	
		})
	}
}